export const SectionHeading = ({ eyebrow, title, description, align = "left", id }) => {
  const alignClasses = align === "center" ? "items-center text-center mx-auto" : "items-start text-left";
  return (
    <div className={`flex max-w-2xl flex-col gap-4 ${alignClasses}`}>
      {eyebrow && (
        <span className="eyebrow" data-testid={id ? `${id}-eyebrow` : undefined}>
          {eyebrow}
        </span>
      )}
      <h2
        className="text-3xl font-semibold leading-tight tracking-[-0.01em] text-foreground sm:text-4xl"
        data-testid={id ? `${id}-title` : undefined}
      >
        {title}
      </h2>
      <span className="gold-line" aria-hidden="true" />
      {description && (
        <p className="text-base leading-relaxed text-muted-foreground sm:text-lg">{description}</p>
      )}
    </div>
  );
};
